module.exports = __webpack_public_path__ + "img/big.54fd5c22.jpg";